import { render, staticRenderFns } from "./KitchenSink.vue?vue&type=template&id=909c7350&scoped=true&"
import script from "./KitchenSink.vue?vue&type=script&lang=js&"
export * from "./KitchenSink.vue?vue&type=script&lang=js&"
import style0 from "./KitchenSink.vue?vue&type=style&index=0&id=909c7350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909c7350",
  null
  
)

export default component.exports